// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { SalesQueries } from '../../../../types/server/modules/sales/queries';

export type * from '../../../../types/server/modules/sales/queries';

export const createQueries = ( requests: Requests ): SalesQueries => ({
  SalesAccountConfigurationById: ( id, query, headers ) => { 
          return requests.get( `/sales/account-configuration/${id}`, query, headers ); 
        },
  SalesAccountConfiguration: ( params?, headers? ) => {
        return requests.get( `/sales/account-configuration/:id?`, params, headers );
      },
  SalesOrdersSearch: ( params?, headers? ) => {
        return requests.get( `/sales/orders-search/:search?`, params, headers );
      },
  SalesOrdersIds: ( params?, headers? ) => {
        return requests.get( `/sales/ordersIds`, params, headers );
      },
  SalesOrdersCount: ( params?, headers? ) => {
        return requests.get( `/sales/orders-count/`, params, headers );
      },
  SalesOrdersById: ( id, query, headers ) => { 
          return requests.get( `/sales/orders/${id}`, query, headers ); 
        },
  SalesOrders: ( params?, headers? ) => {
        return requests.get( `/sales/orders/:id?`, params, headers );
      },
  SalesCustomersSearch: ( params?, headers? ) => {
        return requests.get( `/sales/customers-search/:search?`, params, headers );
      },
  SalesCustomersById: ( id, query, headers ) => { 
          return requests.get( `/sales/customers/${id}`, query, headers ); 
        },
  SalesCustomers: ( params?, headers? ) => {
        return requests.get( `/sales/customers/:id?`, params, headers );
      },
  SalesOrderStatuses: ( params?, headers? ) => {
        return requests.get( `/sales/order-statuses`, params, headers );
      },
  SalesAnalyticsReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/sales-analytics-readmodel/${id}`, query, headers ); 
        },
  SalesAnalyticsReadmodel: ( params?, headers? ) => {
        return requests.get( `/sales-analytics-readmodel/:id?`, params, headers );
      },
  ReversalFactReadmodelById: ( id, query, headers ) => { 
          return requests.get( `/reversal-fact-readmodel/${id}`, query, headers ); 
        },
  ReversalFactReadmodel: ( params?, headers? ) => {
        return requests.get( `/reversal-fact-readmodel/:id?`, params, headers );
      },
  CrmQuestionsById: ( id, query, headers ) => { 
          return requests.get( `/crm/questions/${id}`, query, headers ); 
        },
  CrmQuestions: ( params?, headers? ) => {
        return requests.get( `/crm/questions/:id?`, params, headers );
      },
  SalesMessagingMessagesById: ( id, query, headers ) => { 
          return requests.get( `/sales/messaging/messages/${id}`, query, headers ); 
        },
  SalesMessagingMessages: ( params?, headers? ) => {
        return requests.get( `/sales/messaging/messages/:id?`, params, headers );
      },
  SalesMessagingOutboundMessagesById: ( id, query, headers ) => { 
          return requests.get( `/sales/messaging/outbound-messages/${id}`, query, headers ); 
        },
  SalesMessagingOutboundMessages: ( params?, headers? ) => {
        return requests.get( `/sales/messaging/outbound-messages/:id?`, params, headers );
      }
});
